import React from 'react'
import { Modal } from 'react-bootstrap'
import { t } from 'ttag'
import { Link, Redirect, useHistory } from 'react-router-dom'

const LibraryPricing = () => {
  const history = useHistory()
  const onCancel = () => {
    history.push('/')
  }

  return (
    <Modal show={true} bsSize="lg" onHide={onCancel} dialogClassName="fullscreen-modal">
      <Modal.Body style={{ padding: 0 }}>
        <div className="row" style={{ display: 'flex' }}>
          <div
            className="left-modal-col section"
            style={{
              minHeight: '80vh',
              float: 'left',
              width: '30%',
              padding: '25px',
              backgroundColor: '#6a3460'
            }}>
            <h2 style={{ color: 'white', fontWeight: '300', marginBottom: '25px' }}>
              Pricing
            </h2>
            <p style={{ color: 'white' }}>
              CareerExplorer provides a comprehensive collection of career exploration and
              planning resources, including self-assessments, resume and reference
              writing, occupations and training, and job postings. It provides full
              coverage for 900 occupations, 8,000 industry certifications and 4,200
              postsecondary institutions spanning 16 career clusters. It also contains
              comprehensive labor market information, including in-demand occupations,
              wages, and employment data. Appropriate for ages 8 and up.
            </p>
            <p style={{ color: 'white', paddingTop: '25px' }}>
              *K-16 libraries may license the CareerExplorer career information database
              using the following pricing:{' '}
              <a
                href="https://headed2.com/pricing"
                style={{ color: 'white', fontWeight: 'bold' }}>
                https://headed2.com/pricing
              </a>
              .
            </p>
            <Link
              to={'/quote'}
              className="btn btn-success btn-invert btn-lg navbar-btn pull-right">
              Contact Us
            </Link>
          </div>
          <div
            className="right-modal-col"
            style={{
              minHeight: '80vh',
              float: 'left',
              width: '70%',
              padding: '25px 15px',
              backgroundColor: '#fff'
            }}>
            <button
              type="button"
              className="close"
              aria-label={t`Close`}
              onClick={onCancel}>
              <span aria-hidden="true" style={{ fontSize: '2rem' }}>
                ×
              </span>
            </button>

            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Population</th>
                  <th>Library Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Under 25k</td>
                  <td>$11,340.00</td>
                </tr>
                <tr>
                  <td>25k - 50k</td>
                  <td>$14,175.00</td>
                </tr>
                <tr>
                  <td>50k - 100k</td>
                  <td>$17,955.00</td>
                </tr>
                <tr>
                  <td>100k - 200k</td>
                  <td>$28,350.00</td>
                </tr>
                <tr>
                  <td>200k - 300k</td>
                  <td>$39,690.00</td>
                </tr>
                <tr>
                  <td>300k - 400k</td>
                  <td>$51,030.00</td>
                </tr>
                <tr>
                  <td>400k - 500k</td>
                  <td>$60,480.00</td>
                </tr>
                <tr>
                  <td>500k - 600k</td>
                  <td>$70,875.00</td>
                </tr>
                <tr>
                  <td>600k - 700k</td>
                  <td>$73,710.00</td>
                </tr>
                <tr>
                  <td>700k - 800k</td>
                  <td>$79,380.00</td>
                </tr>
                <tr>
                  <td>800k - 900k</td>
                  <td>$83,160.00</td>
                </tr>
                <tr>
                  <td>900k - 1m</td>
                  <td>$85,050.00</td>
                </tr>
                <tr>
                  <td>1m+</td>
                  <td>$141,750.00</td>
                </tr>
              </tbody>
            </table>

            <em>* Headed2 offers discounts to library consortia</em>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export { LibraryPricing }
